import axios from 'axios';
import {
    URL_FETCH_CONFIG,
    URL_SUBMIT_PAGE,
    URL_SUBMIT_ADDITION,
    URL_INFORMATION_STATUS,
    URL_INFORMATION_FINISH,
    URL_SMS_LOGIN,
    URL_LOGIN_RENEWAL,
    URL_SEND_SMS,
    URL_FORM_NOTICE,
    URL_DRAFT_SAVE,
    URL_DRAFT_GET,
} from './constant';
import store from '@/store';
import { getUrlParam } from '@/utils/util';
import { customLog, customType, resultType, apiCategoty, performanceCatetory, radar } from '../common/weblog';
import { getSig4ConfigParams, shouldUseSig4Interceptor } from './sig4';
import { getSig4RequestInterceptor } from '@ks-cqc/ks-fe-sig4-interceptor/perf-fast';
import Cookies from 'js-cookie';


// 信息收集的数据量略大，延长超时时限
axios.defaults.timeout = 10e3;
const laneId = getUrlParam('laneId');

const CANCEL_ERROR_MESSAGE = '请求被取消了';
const DEFAULT_ERROR_MESSAGE = '请求出错了，请稍后再试';
function rejectHandle(errData) {
    return Promise.reject(errData);
}
function getUrlTypeApi(url) {
    const urlApi = url.match(/[^/]+$/);
    return urlApi[0] || '';
}
function generateRandomThreeDigitNumber() {
    return Math.floor(Math.random() * 900) + 100;
}

const useSig4Interceptors = shouldUseSig4Interceptor();

// 安全地初始化sig4拦截器
const sig4RequestInterceptor = getSig4RequestInterceptor({
    ...getSig4ConfigParams(),
    debug: false,
    // debug: process.env.NODE_ENV === 'development',
    prefetchSigSdk: true,
    projectInfo: {
        oversea: false, // 默认false
        appKey: '8NFTvh9XS9',
        uid: Cookies.get('userId') || Cookies.get('uid'),
        did: Cookies.get('did') || '',
    },
    radar: radar,
});

axios.interceptors.response.use(res => {
    // 缺省后端错误result!=1
    if (res.data.result !== 1) {
        const config = res.config;
        const { url, randomId = '', requestCk = '' } = config;
        const urlApi = url.match(/[^/]+$/);
        customLog({
            type: customType.Api,
            result: resultType.Fail,
            category: apiCategoty.biz,
            message: res.data.error_msg || '缺省后端错误result!=1',
            extra: {
                randomId,
                url: config.url,
                urlTypeApi: urlApi[0] || '',
                ck: requestCk,
                data: res.data,
            },
        });
        return Promise.reject({ message: res.data.error_msg,
            config: res.config });
    }
    let resData = res.data || '';
    // 判断是否是load接口
    try {
        if (res.config.url.includes('/load')) {
            resData = resData.data || '';
        }
    } catch (e) {
        //
    }
    customLog({
        type: customType.Api,
        category: apiCategoty.success,
        result: resultType.Success,
        extra: {
            randomId: res.config.randomId || '',
            data: resData,
            url: res.config.url,
        },
    });
    return res;
}, error => {

    if (!error.config || !error.config.url) {
        return rejectHandle(CANCEL_ERROR_MESSAGE);
    }
    const config = error.config;
    const { requestCk = '', randomId = '' } = config;
    customLog({
        type: customType.Api,
        category: apiCategoty.network,
        result: resultType.Fail,
        message: error.error_msg || '缺省网络请求错误code!=200',
        extra: {
            url: config.url,
            urlTypeApi: getUrlTypeApi(config.url) || '',
            data: error.response.data || '',
            ck: requestCk,
            randomId,
        },
    });
    return rejectHandle(error || DEFAULT_ERROR_MESSAGE);
});

useSig4Interceptors && axios.interceptors.request.use(sig4RequestInterceptor);
axios.interceptors.request.use(function (config) {
    const { url } = config;
    const urlApi = url.match(/[^/]+$/);
    config.requestCk = document.cookie ? document.cookie.length : 0;
    const randomId = `${generateRandomThreeDigitNumber()}-${Date.now()}`;
    config.randomId = randomId;
    customLog({
        type: customType.Api,
        category: apiCategoty.request,
        result: resultType.Pending,
        extra: {
            ck: config.requestCk,
            randomId,
            url: url,
            urlTypeApi: urlApi[0] || '',
            data: config.data,
        },
    });
    const from = store.state.from;
    if (config.method === 'post') {
        const data = {
            from,
            ...config.data,
        };
        config.data = data;
    } else if (config.method === 'get') {
        config.params = {
            from,
            ...config.params,
        };
    }
    if (laneId) {
        config.headers['trace-context'] = `{"laneId":"${laneId}"}`;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

export async function fetchConfig(params) {
    const start = (window.performance || Date).now();
    const { bizKey } = params;
    const url = URL_FETCH_CONFIG.replace('{bizKey}', bizKey);
    // 从链接获取 entranceId、gameId、appId、gameVersion，透传给后端
    ['entranceId', 'gameId', 'appId', 'gameVersion'].forEach(key => {
        const value = getUrlParam(key);
        if (value) {
            params[key] = value;
        }
    });
    const data = (await axios.post(url, params)).data;
    const end = (window.performance || Date).now();
    const message = (end - start).toFixed(4);
    customLog({
        type: customType.Performance,
        category: performanceCatetory.api,
        message,
        extra: {
            url,
            bizKey: bizKey,
            urlTypeApi: getUrlTypeApi(URL_FETCH_CONFIG),
        },
    });
    return data;
}

export async function fetchFormNoticeConfig(params) {
    const start = (window.performance || Date).now();
    const { bizKey } = params;
    const url = URL_FORM_NOTICE.replace('{bizKey}', bizKey);
    const data = (await axios.post(url, params)).data;
    const end = (window.performance || Date).now();
    const message = (end - start).toFixed(4);
    customLog({
        type: customType.Performance,
        category: performanceCatetory.api,
        message,
        extra: {
            url,
            bizKey: bizKey,
            urlTypeApi: getUrlTypeApi(URL_FORM_NOTICE),
        },
    });
    return data;
}

export async function postPage(postData) {
    console.warn('postPage postData', postData);
    const start = (window.performance || Date).now();
    const { bizKey } = postData;
    const url = URL_SUBMIT_PAGE.replace('{bizKey}', bizKey);
    // 从链接上取 entranceId，如果有，就加这个参数
    const entranceIdFromUrl = getUrlParam('entranceId');
    console.warn('entranceIdFromUrl', entranceIdFromUrl);
    const requestData = entranceIdFromUrl ? { ...postData, entranceId: entranceIdFromUrl } : postData;
    console.warn('requestData', requestData);
    const data = (await axios.post(url, requestData)).data;
    const end = (window.performance || Date).now();
    const message = (end - start).toFixed(4);
    customLog({
        type: customType.Performance,
        category: performanceCatetory.api,
        message,
        extra: {
            url,
            bizKey: bizKey,
            urlTypeApi: getUrlTypeApi(URL_SUBMIT_PAGE),
        },
    });
    return data;
}

export async function postAddition(postData) {
    const start = (window.performance || Date).now();
    const { bizKey } = postData;
    const url = URL_SUBMIT_ADDITION.replace('{bizKey}', bizKey);
    const res = (await axios.post(url, postData)).data;
    const end = (window.performance || Date).now();
    const message = (end - start).toFixed(4);
    customLog({
        type: customType.Performance,
        category: performanceCatetory.api,
        message,
        extra: {
            url,
            bizKey: bizKey,
            urlTypeApi: getUrlTypeApi(URL_SUBMIT_ADDITION),
        },
    });
    if (res.result !== 1) {
        throw new Error(res.error_msg);
    }
    return res;
}

export async function getInformationStatus(postData) {
    const start = (window.performance || Date).now();
    const { bizKey } = postData;
    const url = URL_INFORMATION_STATUS.replace('{bizKey}', bizKey);
    const res = (await axios.post(url, {
        ...postData,
    })).data;
    const end = (window.performance || Date).now();
    const message = (end - start).toFixed(4);
    customLog({
        type: customType.Performance,
        category: performanceCatetory.api,
        message,
        extra: {
            url,
            bizKey: bizKey,
            urlTypeApi: getUrlTypeApi(URL_INFORMATION_STATUS),
        },
    });
    if (res.result !== 1) {
        const err = new Error(res.error_msg);
        // 保留错误码以判断是否要替换错误页按钮
        err.code = res.result;
        throw err;
    }
    return res;
}

export async function setInformationFinish(postData) {
    const start = (window.performance || Date).now();
    const { bizKey } = postData;
    const url = URL_INFORMATION_FINISH.replace('{bizKey}', bizKey);
    const res = (await axios.post(url, postData)).data;
    const end = (window.performance || Date).now();
    const message = (end - start).toFixed(4);
    customLog({
        type: customType.Performance,
        category: performanceCatetory.api,
        message,
        extra: {
            url,
            bizKey: bizKey,
            urlTypeApi: getUrlTypeApi(URL_INFORMATION_FINISH),
        },
    });
    if (res.result !== 1) {
        throw new Error(res.error_msg);
    }
    return res;
}

export async function postLoginBySms(postData) {
    const start = (window.performance || Date).now();
    const { bizKey } = postData;
    const url = URL_SMS_LOGIN.replace('{bizKey}', bizKey);
    const res = (await axios.post(url, postData)).data;
    const end = (window.performance || Date).now();
    const message = (end - start).toFixed(4);
    customLog({
        type: customType.Performance,
        category: performanceCatetory.api,
        message,
        extra: {
            url,
            bizKey: bizKey,
            urlTypeApi: getUrlTypeApi(URL_SMS_LOGIN),
        },
    });
    return res;
}

export async function postSendSms(postData) {
    const start = (window.performance || Date).now();
    const { bizKey } = postData;
    const url = URL_SEND_SMS.replace('{bizKey}', bizKey);
    const res = (await axios.post(url, postData)).data;
    const end = (window.performance || Date).now();
    const message = (end - start).toFixed(4);
    customLog({
        type: customType.Performance,
        category: performanceCatetory.api,
        message,
        extra: {
            url,
            bizKey: bizKey,
            urlTypeApi: getUrlTypeApi(URL_SEND_SMS),
        },
    });
    return res;
}

export async function postLoginRenewal(postData) {
    const start = (window.performance || Date).now();
    const { bizKey } = postData;
    const url = URL_LOGIN_RENEWAL.replace('{bizKey}', bizKey);
    const res = (await axios.post(url, postData)).data;
    const end = (window.performance || Date).now();
    const message = (end - start).toFixed(4);
    customLog({
        type: customType.Performance,
        category: performanceCatetory.api,
        message,
        extra: {
            url,
            bizKey: bizKey,
            urlTypeApi: getUrlTypeApi(URL_LOGIN_RENEWAL),
        },
    });
    return res;
}

export async function axiosRequest({ method, url, payload, config }) {
    if (!url) {
        // eslint-disable-next-line no-undefined
        return undefined;
    }
    if (axios[method]) {
        let res;
        if (method === 'post') {
            res = (await axios.post(url, payload, config)).data;
        } else {
            // 目前只支持post和get两种方法
            res = (await axios.get(url, { ...config, params: payload })).data;
        }
        if (res.result !== 1) {
            throw new Error(res.error_msg);
        }
        return res;
    }
    console.error(`Invalid Request Method ${method}`);
    // eslint-disable-next-line no-undefined
    return undefined;
}

/**
 * 保存服务端草稿（跨渠道草稿互通）
 * data 为 null 或空对象时，后端执行删除语义
 * @param {string} bizKey - 信息收集业务 key
 * @param {string} from - 入口 fromKey，调用时快照传入，防止防抖延迟触发时 store.state.from 已变更
 * @param {*} data - 草稿内容对象；传 null 时触发删除
 */
export async function saveDraft({ bizKey, from, data }) {
    const url = URL_DRAFT_SAVE.replace('{bizKey}', bizKey);
    const start = (window.performance || Date).now();
    let res;
    try {
        res = (await axios.post(url, { from, data })).data;
    } catch (e) {
        // 接口异常静默降级，不影响主流程
        // console.warn('[saveDraft] 接口异常，静默降级', e);
        return null;
    }
    const end = (window.performance || Date).now();
    const message = (end - start).toFixed(4);
    customLog({
        type: customType.Performance,
        category: performanceCatetory.api,
        message,
        extra: {
            url,
            bizKey,
            urlTypeApi: getUrlTypeApi(URL_DRAFT_SAVE),
        },
    });
    if (res.result !== 1) {
        // console.warn('[saveDraft] 失败，静默降级', res.error_msg);
    }
    return res;
}

/**
 * 获取服务端草稿（跨渠道草稿互通）
 * from 字段由请求拦截器自动注入（来自 store.state.from），无需手动传递
 * @param {string} bizKey - 信息收集业务 key
 * @returns {Promise<{result: number, data: object}>} 草稿响应；无草稿时 data 为 {}
 */
export async function getDraft({ bizKey }) {
    const url = URL_DRAFT_GET.replace('{bizKey}', bizKey);
    const start = (window.performance || Date).now();
    const res = (await axios.post(url, {})).data;
    const end = (window.performance || Date).now();
    const message = (end - start).toFixed(4);
    customLog({
        type: customType.Performance,
        category: performanceCatetory.api,
        message,
        extra: {
            url,
            bizKey,
            urlTypeApi: getUrlTypeApi(URL_DRAFT_GET),
        },
    });
    return res;
}
